angular.module('app').directive('uiNav', [
    function() {
        return {
            restrict: 'AC',
            link: function(scope, el, attr) {
                var _window = $(window);
                var _mb = 768;
                var next;

                el.on('click', 'a', function(e) {
                    next && next.trigger('mouseleave.nav');
                    var _this = $(this);
                    _this
                        .parent()
                        .siblings('.active')
                        .toggleClass('active');
                    _this.next().is('ul') && _this.parent().toggleClass('active') && e.preventDefault();

                    _this.next().is('ul') || (_window.width() < _mb && $('.off-screen').removeClass('show off-screen'));
                    $(this)
                        .parents('.navi')
                        .siblings('.app-header')
                        .find('button.hamburger')
                        .click();
                });
            },
        };
    },
]);
